import axios from 'axios';
import API_BASE_URL from '../config.js';

const getSalients = async (event) => {

    const response = await axios.get(`${API_BASE_URL}/salient/`,
    );

    return response.data;

};

export default getSalients 
